<template>
  <div>
    <div style="width:100%">
      <h3 class="normal">猩号意见反馈</h3>
      <table
        width="100%"
        cellspacing="0"
        cellpadding="0"
        border="0"
        class="table-opinion"
      >
        <th>
          <tr>
            <td style="width:700px;">示意图</td>
            <td style="width:20%">建议描述</td>
            <td style="width:10%">平台</td>
            <td style="width:10%">操作</td>
            <td style="width:40%;">聊天记录</td>
          </tr>
          <tr>
            <td>
              <div>
                <input
                  type="file"
                  @change="chooseImage"
                  id="xinghaoimage"
                  multiple
                />
              </div>
              <div
                v-if="srcList.length > 0"
                style="display:flex;margin-left:150px;"
              >
                <div
                  v-for="(src, index) in srcList"
                  :key="index"
                  class="imageBoxMini"
                >
                  <img :src="src" preview="3" preview-text="猩号建议图" />
                  <button
                    @click="delImage(index);"
                    style="display:block;width:50px;text-align:center;"
                  >
                    删除
                  </button>
                </div>
              </div>
            </td>
            <td>
              <el-input v-model="describe" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <select v-model="platform">
                <option value="安卓">安卓</option>
                <option value="ios">ios</option>
              </select>
            </td>
            <td>
              <el-button type="primary" @click="saveInfo();">保存</el-button>
            </td>
          </tr>
        </th>
      </table>
      <div style="display:flex;">
        <div>
          <el-table
            :data="opinionList"
            stripe
            style="width:100%;margin-top:50px;"
            border
          >
            <el-table-column
              prop="picture"
              label="示意图"
              width="400"
              align="center"
            >
              <template slot-scope="scope">
                <div style="display:flex;">
                  <div v-for="(p, index) in scope.row.images" :key="index">
                    <img
                      style="width: 100px; height: 100px"
                      :src="p"
                      preview="3"
                      preview-text="猩号建议图"
                    />
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="describe"
              label="建议描述"
              width="400"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="platform"
              label="平台"
              width="200"
              :filters="[
                { text: '安卓', value: '安卓' },
                { text: 'ios', value: 'ios' }
              ]"
              :filter-method="filterHandler"
              :filtered-value="['安卓']"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="时间"
              width="200"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <select
                  v-model="scope.row.status"
                  @change="changestatus(scope.row);"
                >
                  <option value="待讨论">待讨论</option>
                  <option value="暂缓">暂缓</option>
                  <option value="拒绝">拒绝</option>
                  <option value="开发中">开发中</option>
                  <option value="已完成">已完成</option>
                </select>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="chat-record">
          <div v-for="(chat, index) in chatsList" :key="index" class="onechat">
            <div class="userchat">
              <img
                :src="chat.avatar"
                style="width:50px;height:50px;border-radius:50%;"
              />
              <div>{{ chat.nickname }}</div>
            </div>
            <div>
              <div v-if="chat.type == 1" class="onechatcontent">
                {{ chat.content }}
              </div>
              <div
                v-if="chat.type == 2"
                class="onechatcontent"
                @click="addTalkImage(chat.content);"
              >
                <img
                  :src="chat.content"
                  preview="3"
                  preview-text="猩号建议图"
                />
              </div>
              <div style="margin-left:15px;">
                发布时间：{{ chat.create_time }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      opinionList: [],
      xinghao_image: "",
      describe: "",
      pictureList: [],
      srcList: [],
      chatsList: [],
      platform: ""
    };
  },
  created() {
    let that = this;
    that.$axios.get(that.$url_prefix + "task/list", {}).then(res => {
      console.log(res);
      if (res.status) {
        that.opinionList = res.data.data.reverse() || [];
      }
    });
    that.$axios.get(that.$url_prefix + "task/talklist", {}).then(res => {
      if (res.status) {
        this.chatsList = res.data.data;
      }
    });
  },
  methods: {
    changestatus(row) {
      console.log(row);
      let id = row._id;
      let status = row.status;
      this.$axios
        .get(this.$url_prefix + "task/status/set", {
          params: {
            task_id: id,
            status
          }
        })
        .then(res => {});
    },
    saveInfo() {
      this.pictureList = [...this.pictureList, ...this.srcList];
      let opinion = {
        images: this.pictureList,
        describe: this.describe,
        platform: this.platform
      };
      let params = {
        images: this.pictureList,
        describe: this.describe,
        platform: this.platform
      };
      let that = this;
      this.$axios.post(this.$url_prefix + "task/create", params).then(res => {
        if (res.status == 200) {
          that.$axios.get(that.$url_prefix + "task/list", {}).then(res => {
            console.log(res);
            if (res.status) {
              that.opinionList = res.data.data.reverse() || [];
            }
          });
          that.$message({
            type: "success",
            message: "保存成功"
          });
          this.pictureList = [];
          this.describe = "";
          this.srcList = [];
          this.platform = "";
        }
      });
    },
    delImage(i) {
      // 删除其它图片
      this.srcList.splice(i, 1);
    },
    chooseImage(event) {
      // 上传图片
      let that = this;
      let option = {
        file: event.target.files[0],
        head_name: "RealEstate"
      };
      that
        .$uploadImage(option)
        .then(function(res) {
          console.log("upload back", res);
          if (!res) {
            console.log("upload fail");
            return false;
          }
          if (res === "图片太大") {
            that.$message.error("图片太大了");
            return false;
          }
          that.xinghao_image = res;
          that.srcList.push(res);
          that.$previewRefresh();
          that.$message({
            type: "success",
            message: "上传成功"
          });
        })
        .catch(function(res) {
          console.log("upload fail", res);
        });
    },

    addTalkImage(url) {
      if (!this.srcList.includes(url)) {
        this.srcList.push(url);
      }
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      if (value == row[property]) {
        return true;
      }
    }
  }
};
</script>
<style scoped>
.normal {
  display: inline-block;
  text-align: center;
  width: 100%;
  margin: 100px 0;
}
.table-opinion tr {
  margin: 10px 0;
}
.table-opinion td {
  vertical-align: middle;
}
.cell img {
  width: 100px;
  height: 100px;
}
.cell {
  display: flex;
}
.cell > div {
  margin-right: 50px;
}
.chat-record {
  width: 36%;
  height: 500px;
  border: 1px solid #ccc;
  overflow-y: auto;
  padding: 20px;
  border-radius: 20px;
  margin-top: 45px;
  margin-left: 10px;
}
.imageBoxMini img {
  width: 50px;
  height: 50px;
}
.imageBoxMini {
  margin-left: 20px;
}
.onechat {
  display: flex;
  margin-bottom: 20px;
}
.onechatcontent {
  border: 1px solid #000;
  padding: 0 5px;
  border-radius: 5px;
  margin-left: 10px;
  vertical-align: middle;
}
.onechatcontent img {
  width: 200px;
  height: 200px;
}
.userchat {
  width: 50px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/opinion.vue